import { render, staticRenderFns } from "./ComparativoQtdAisBdgd.vue?vue&type=template&id=1b661716&"
import script from "./ComparativoQtdAisBdgd.vue?vue&type=script&lang=js&"
export * from "./ComparativoQtdAisBdgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports